import "./App.css";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { LangProvider } from "./contexts/LangContext";
import Layout from "./components/Layout";
import { LANDING_SLUGS } from "./lib/landingPages";

const Home = lazy(() => import("./pages/Home"));
const Occasions = lazy(() => import("./pages/Occasions"));
const OccasionDetail = lazy(() => import("./pages/OccasionDetail"));
const Diensten = lazy(() => import("./pages/Diensten"));
const Over = lazy(() => import("./pages/Over"));
const Reviews = lazy(() => import("./pages/Reviews"));
const Contact = lazy(() => import("./pages/Contact"));
const Afspraak = lazy(() => import("./pages/Afspraak"));
const Inruil = lazy(() => import("./pages/Inruil"));
const Nieuws = lazy(() => import("./pages/Nieuws"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Voorwaarden = lazy(() => import("./pages/Voorwaarden"));
const NotFound = lazy(() => import("./pages/NotFound"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const Landing = lazy(() => import("./pages/Landing"));

function PageFallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-black">
      <div className="w-10 h-10 border-2 border-white/10 border-t-[#e60000] rounded-full animate-spin" />
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/occasions" element={<Occasions />} />
                  <Route path="/occasions/:id" element={<OccasionDetail />} />
                  <Route path="/diensten" element={<Diensten />} />
                  <Route path="/over-ons" element={<Over />} />
                  <Route path="/reviews" element={<Reviews />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/afspraak" element={<Afspraak />} />
                  <Route path="/inruil" element={<Inruil />} />
                  <Route path="/nieuws" element={<Nieuws />} />
                  {LANDING_SLUGS.map((slug) => (
                    <Route key={slug} path={`/${slug}`} element={<Landing slug={slug} />} />
                  ))}
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/voorwaarden" element={<Voorwaarden />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: "#0a0a0a",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 0,
              },
            }}
          />
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
